// Preferences belong to one browser account and never grant access to a Space.
export const lastSpaceKey = userId => `iio-last-space:${encodeURIComponent(userId)}`;
export const approvalViewKey = userId => `iio-approval-view:${encodeURIComponent(userId)}`;

function read(key, userId) {
  if (!userId) return "";
  try { return window.localStorage.getItem(key(userId)) || ""; } catch { return ""; }
}
function write(key, userId, value) {
  if (!userId || !value) return;
  try { window.localStorage.setItem(key(userId), value); } catch { /* Storage is optional. */ }
}
export const readLastSpace = userId => read(lastSpaceKey, userId);
export const rememberSpace = (userId, spaceId) => write(lastSpaceKey, userId, spaceId);
export const readApprovalView = userId => read(approvalViewKey, userId) === "stages" ? "stages" : "packages";
export const rememberApprovalView = (userId, value) => {
  if (["packages", "stages"].includes(value)) write(approvalViewKey, userId, value);
};
